<template>
  <div class="box instructions-box">
    <div class="instructions-header" @click="toggleMobile">
      <h4 class="title is-5 instructions-title">
        <b-icon icon="information-outline" size="is-small" class="mr-2"></b-icon>
        Instructions
      </h4>
      <b-icon :icon="isExpanded ? 'chevron-up' : 'chevron-down'" class="toggle-icon"></b-icon>
    </div>
    <div class="instructions-content" :class="{ 'is-collapsed': !isExpanded }">
      <hr />
      <p class="block">
        To create a new inquiry, select one of your available Providers and one of the available
        Payers.
      </p>
      <h6 class="subtitle is-6 mb-1 mt-4 has-text-weight-semibold">Providers</h6>
      <p class="block">
        You can select any of your previously configured providers. If the provider you would like
        to use isn't available,
        <span v-if="isManager">
          you can add a
          <router-link :to="{ name: 'ProviderCreate' }">new provider</router-link>
          .
        </span>
        <span v-else>you can ask the organization manager to add it for you.</span>
      </p>
      <h6 class="subtitle is-6 mb-1 mt-4 has-text-weight-semibold">Payers</h6>
      <p class="block">
        All of our available Payers are listed here. We actively monitor and update this list.
      </p>
      <p class="block">
        Before running an inquiry, you can check whether a payer is currently down on the
        <router-link :to="{ name: 'PayerOutageList' }">payer outage page</router-link>
        . A payer that is temporarily down will usually be back within the hour.
      </p>
      <hr class="aq-helper" />
      <p class="block">
        Once you've selected a payer and provider, the payer's allowed, and required fields will be
        displayed.
      </p>
      <p class="block">
        <strong>Required fields</strong>
        are denoted with a
        <strong>*</strong>
        in the field label.
      </p>
      <p class="block">
        <strong>As of Date</strong>
        is the date that you would like to search for coverage. By default, it will be
        <em>today's</em>
        date.
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'InquiryFormInstructions',
  data() {
    return {
      isExpanded: window.innerWidth > 1024,
      isMobile: window.innerWidth <= 1024,
    };
  },
  computed: {
    ...mapGetters(['isManager']),
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    toggleMobile() {
      if (this.isMobile) {
        this.isExpanded = !this.isExpanded;
      }
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 1024;
      if (!this.isMobile) {
        this.isExpanded = true;
      }
    },
  },
};
</script>

<style scoped>
.instructions-box {
  background-color: #fff;
  border: 1px solid #e9ecef;
}

.instructions-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.instructions-title {
  display: flex;
  align-items: center;
  color: #495057;
  margin-bottom: 0 !important;
}

.toggle-icon {
  display: none;
  color: #6c757d;
  transition: transform 0.2s ease;
}

.instructions-content {
  overflow: hidden;
  transition:
    max-height 0.3s ease,
    opacity 0.3s ease;
  max-height: 1000px;
  opacity: 1;
}

hr {
  background-color: #dee2e6;
  height: 1px;
  margin: 1rem 0;
}

hr.aq-helper {
  background-color: #dee2e6;
  height: 1px;
  margin: 1.25rem 0;
}

.block {
  font-size: 0.95rem;
  color: #555;
  line-height: 1.6;
}

.subtitle.is-6 {
  color: #363636;
}

@media (max-width: 1024px) {
  .instructions-header {
    cursor: pointer;
  }

  .toggle-icon {
    display: block;
  }

  .instructions-content.is-collapsed {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
  }
}
</style>
